export default __webpack_public_path__ + "static/media/acceptTick.04cbd0d3.svg";